import React from 'react'
import ffffff from '../image/ffffff.avif'
import { styled } from '@mui/system'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}))

function RO_FAQ_page() {
  return (
    <div>
      <div className="mt-5">
        <div className="container pt-3">
          <div className="text-center Curriculum_Main_text">
            <div className="">
              <h2 className="display-6">Frequently Asked Questions</h2>
              <p className="pt-2">
                Our Responses to Your Inquiries: Unblocking the Way to Clarity
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-5">
              <div className="FAQ_img">
                <img
                  src={ffffff}
                  onContextMenu={(e) => e.preventDefault()}
                ></img>
              </div>
            </div>
            <div className="col-md-7 pt-5 d-none d-md-block">
              <div className="pt-5">
                <div className="pt-5">
                  <div className="pt-5">
                    <RO_FAQ />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 d-sm-block d-md-none mb-5">
              <RO_FAQ />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function RO_FAQ() {
  const classes = useStyles()
  const [expanded, setExpanded] = React.useState(false)

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }

  return (
    <div className={classes.root}>
      <Accordion
        className="py-2"
        expanded={expanded === 'panel1'}
        onChange={handleChange('panel1')}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
          className="FAQ_background_color"
        >
          <Typography style={{ fontSize: '1.2rem' }}>
            Why should I learn Robotics?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Robotics is a fast-growing field with applications in AI, manufacturing, healthcare, and autonomous vehicles. Learning robotics develops problem-solving, programming, and engineering skills, opening diverse career opportunities.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === 'panel2'}
        onChange={handleChange('panel2')}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
          className="FAQ_background_color"
        >
          <Typography style={{ fontSize: '1.2rem' }}>
            How is Robotics different from traditional automation, and why does it matter?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
           Automation is about machines performing repetitive, pre-set tasks, while robotics goes beyond that by combining automation with sensors, actuators, and artificial intelligence. This allows robots to not only follow instructions but also adapt to different environments and make independent decisions.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === 'panel3'}
        onChange={handleChange('panel3')}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
          className="FAQ_background_color"
        >
          <Typography style={{ fontSize: '1.2rem' }}>
            What are the key skills and subjects I need to start a career in Robotics?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Students entering robotics need a mix of technical and creative skills. Essential knowledge includes programming languages (like Python, C/C++), electronics and circuits, mechanical design, control systems, and AI fundamentals. Equally important are problem-solving skills and curiosity to experiment.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === 'panel4'}
        onChange={handleChange('panel4')}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
          className="FAQ_background_color"
        >
          <Typography style={{ fontSize: '1.2rem' }}>
           Why is Robotics considered a future-proof career, and how does it benefit students?

          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Robotics combines multiple fields like AI, IoT, and engineering, all of which are shaping the future. Students who learn robotics gain skills that are highly in demand, making them competitive and future-ready across industries worldwide.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === 'panel5'}
        onChange={handleChange('panel5')}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel5bh-content"
          id="panel5bh-header"
          className="FAQ_background_color"
        >
          <Typography style={{ fontSize: '1.2rem' }}>
            How is robotics connected to Artificial Intelligence (AI)?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          AI enables robots to learn, adapt, and make decisions. Combining robotics with AI creates intelligent machines capable of performing complex tasks like self-driving, object recognition, and human interaction.

          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  )
}

export default RO_FAQ_page
